import makeAsyncScriptLoader from 'react-async-script';

const WebexLib = ({ onLoad }) => {
    return null;
}

const WebexLibWrapper = makeAsyncScriptLoader('https://binaries.webex.com/static-content-pipeline/webex-embedded-app/v1/webex-embedded-app-sdk.js')(WebexLib);
export default WebexLibWrapper;
